export default __webpack_public_path__ + "static/fde16880-e6d7-449c-aef2-7aa6dd977118-100537a9b58312aa28bc7c67967c2e17.woff2";